module.exports = __webpack_public_path__ + "img/automatic_bottom_lock_box1.85310f7a.png";